/* eslint-disable react/jsx-indent */
import React, { useState, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { SIDENAV_KEYS, LANDING_KEYS } from '../../utils/translation-constants'
import Loading from 'custom/assets/loaders/Loading'
import ExchangesRatesService from '../../services/exchange-rates.service'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import { useHistory } from 'react-router-dom'

export default function ExchangeRates() {
  const { t } = useTranslation()
  const history = useHistory()
  const [stage, setStage] = useState(0)
  const [loadingState, setLoadingState] = useState(false)
  const [sellCurrencyValues, setSellCurrencyValues] = useState([])

  const getCurrencyExchanges = useCallback(async () => {
    try {
      setStage(0)
      const response = await ExchangesRatesService.getallExchangeRates()
      setSellCurrencyValues(response.crossCurRateList)
      setStage(1)
      setLoadingState(false)
    } catch (err) {
      setLoadingState(false)
      setStage(1)
      setSellCurrencyValues([])
    }
  }, [])

  useEffect(() => {
    getCurrencyExchanges()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderExchangeRatesForm()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderExchangeRatesForm() {
    return (
      <div>
        {sellCurrencyValues.length > 0 && (
          <div>
            <div className='heading5'>
              <div className='headingCell5'>{t(SIDENAV_KEYS.EXCHANGE_RATE_KEYS.TITLE)}</div>
              <div className='headingCell5'>{t(SIDENAV_KEYS.EXCHANGE_RATE_KEYS.BUY_RATE)}</div>
              <div className='headingCell5'>{t(SIDENAV_KEYS.EXCHANGE_RATE_KEYS.SELL_RATE)}</div>
            </div>
            {sellCurrencyValues.map((item, index) => (
              <div className='row5' key={index}>
                <div className='cell5'>{item.symbol}</div>
                <div className='cell5'>{item.buyRate}</div>
                <div className='cell5'>{item.saleRate}</div>
              </div>
            ))}
          </div>
        )}

        {sellCurrencyValues.length === 0 && <p>{t(LANDING_KEYS.NO_RECORD)}</p>}
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='EXCHANGE_RATES'
      showEmptySpace={true}
      keyPath={'EXCHANGE_RATES'}>
      <div className=''>
        {/* <div className='heading-style'>Exchange Rates</div> */}
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}
